export const paymentMethods = {
  MY_DUITNOW: 'Via Mobile Number',
  // bank: 'Via Account Number',
};

export const banks = {
  maybank: 'Maybank',
  publicbank: 'Public Bank',
};
